import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import { DialogShow_2 } from "../../../components/DialogService/DialogService";

//PAGE
import P402List from "./P402List";
import P402Search from "./P402Search";
import P402Search2 from "./P402Search2";
import P402List2 from "./P402List2";
import P402Dialog from "./P402Dialog";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P402CreateData, P402CreateData2, P402GetDataList, P402GetDataList2 } from "../../../service/400/P402Service";
import { genContractorStaffTypeList } from "../../../service/GEN/GenService";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { NullInt } from "../../../utilities/NullUtil";

export default function P402() {
    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    const [action, setAction] = useState({ tab: 1, action: "บันทึก" });
    const [textShow, setTextShow] = useState("");

    const [submittedHeader, setSubmittedHeader] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [showDialog, setShowDialog] = useState(false);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData] = useState({
        searchWord: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });
    const [searchDataA, setSearchDataA] = useState({
        contractorCode: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    const [staffType, setStaffType] = useState([]);
    const [searchWord, setSearchWord] = useState("");
    const [data, setData] = useState({
        contractorCode: "",
        contractorName: "",
    });
    const [dataTable, setDataTable] = useState([]);
    const [dataTableA, setDataTableA] = useState([]);

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onP402GetDataList();
        onGenContractorStaffTypeList();
    }, [searchData]);

    useEffect(() => {
        if (action.tab === 1) {
            onP402GetDataList();
        }
    }, [action]);

    useEffect(() => {
        // if(searchDataA.contractorCode !== ''){
        onP402GetDataList2();
        // }
    }, [searchDataA]);

    const onP402GetDataList = () => {
        setLoading(true);
        P402GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP402GetDataList2 = () => {
        setLoading(true);
        P402GetDataList2(searchDataA).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });

                    if (temp.length > 0) {
                        setData(temp[0]);
                    }

                    if (temp.length >= 1) {
                        if (temp[0].staffSeq && !(NullInt(temp[0].staffSeq) === 0)) {
                            setDataTableA(temp);
                        } else {
                            setDataTableA([]);
                        }
                    } else {
                        setDataTableA([]);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenContractorStaffTypeList = () => {
        setLoading(true);
        genContractorStaffTypeList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setStaffType(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const submitFormSearch = (submitForm) => {
        setLoading(true);
        let newData = {
            userId: searchData.userId,
            searchWord: submitForm,
        };

        P402GetDataList(newData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const submitForm = (submitForm, actionForm) => {
        if (validation(submitForm, "staff")) {
            setLoading(true);
            if (actionForm === "ลบรายการ") {
                submitForm = {
                    contractorCode: submitForm.contractorCode,
                    staffId: submitForm.staffSeq,
                    staffName: submitForm.staffName,
                    staffPosition: submitForm.staffPositionCode,
                    telephone: submitForm.staffTelephone,
                    userId: searchData.userId,
                    actionCode: "D",
                };
            } else if (dialog.action === "บันทึก") {
                submitForm = {
                    contractorCode: submitForm.contractorCode,
                    staffId: 0,
                    staffName: submitForm.staffName,
                    staffPosition: submitForm.staffPositionCode,
                    telephone: submitForm.staffTelephone,
                    userId: searchData.userId,
                    actionCode: "A",
                    status: submitForm.status === undefined ? "A" : submitForm.status,
                };
            } else if (dialog.action === "แก้ไข") {
                submitForm = {
                    contractorCode: submitForm.contractorCode,
                    staffId: submitForm.staffSeq,
                    staffName: submitForm.staffName,
                    staffPosition: submitForm.staffPositionCode,
                    telephone: submitForm.staffTelephone,
                    userId: searchData.userId,
                    actionCode: "U",
                    status: submitForm.status,
                };
            }
            P402CreateData2(submitForm).then(
                (res) => {
                    setLoading(false);
                    setDialog(false);

                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                            // seqPk: 1, statusCode: 'C', statusText: ''
                        } else {
                            setTextShow(`${res.data[0].statusText}`);
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                    onP402GetDataList2();
                },
                function (err) {
                    setDialog(false);
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const submitFormHeader = (submitForm, actionForm) => {
        if (validation(submitForm, "contractor")) {
            setLoading(true);
            if (actionForm === "ลบรายการ") {
                submitForm = {
                    ...submitForm,
                    userId: searchData.userId,
                    actionCode: "D",
                };
            } else if (action.action === "บันทึก") {
                submitForm = {
                    ...submitForm,
                    userId: searchData.userId,
                    actionCode: "A",
                };
            } else if (action.action === "แก้ไข") {
                submitForm = {
                    ...submitForm,
                    userId: searchData.userId,
                    actionCode: "U",
                };
            }
            P402CreateData(submitForm).then(
                (res) => {
                    setLoading(false);
                    setDialog(false);

                    if (res.status === 200) {
                        if (res.data[0].statusText === "") {
                            if (res.data[0].statusCode === "C") {
                                setTextShow(`บันทึกสมบูรณ์ `);
                                if (actionForm === "ลบรายการ") {
                                    setAction({ tab: 1 });
                                } else if (action.action === "บันทึก") {
                                    setAction({ action: "แก้ไข", tab: 2 });
                                }
                            } else if (res.data[0].statusCode === "E") {
                                setTextShow(`มีข้อผิดพลาด`);
                            }
                            // seqPk: 1, statusCode: 'C', statusText: ''
                        } else {
                            setTextShow(`${res.data[0].statusText}`);

                            // new 31/03/2022
                            setAction({ action: "แก้ไข", tab: 2 });
                        }
                        setShowDialog(true);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }

                    // onP402_2GetDataList();
                },
                function (err) {
                    setDialog(false);
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const validation = (object, type) => {
        if (type === "staff") {
            if (object.staffName === "" || object.staffPositionCode === "" || object.staffTelephone === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        } else if (type === "contractor") {
            if (!object.contractorCode || object.contractorCode === "" || !object.contractorName || object.contractorName === "") {
                setSubmittedHeader(true);
                return false;
            } else {
                setSubmittedHeader(false);
                return true;
            }
        }
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="card">
                    <h2 className="p-m-0">บริษัทคู่สัญญา</h2>
                    <hr />
                    {action && action.tab === 2 ? (
                        <>
                            <P402Search2 action={action} data={data} setData={setData} submitted={submittedHeader} />
                            <P402List2 dataTable={dataTableA} setDialog={setDialog} action={action} data={data} setAction={setAction} submitForm={submitFormHeader} />
                        </>
                    ) : (
                        <>
                            <P402Search setSearchWord={setSearchWord} searchWord={searchWord} submitForm={submitFormSearch} />
                            <P402List dataTable={dataTable} searchData={searchDataA} setSearchData={setSearchDataA} setAction={setAction} setData={setData} />
                        </>
                    )}
                </div>

                {dialog.dialog === true ? (
                    <>
                        <P402Dialog dialog={dialog} setDialog={setDialog} staffType={staffType} data={data} submitForm={submitForm} submitted={submitted} />
                    </>
                ) : (
                    ""
                )}

                <DialogShow_2 visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
            </div>
        </>
    );
}
